import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  doctorListRecords: [],
  appointmentSlots: [],
  staffRecords: [],
  rescheduleSuccess: false,
  appointmentCounts: [],
  totalSchedule: 0,
  nurseListRecords: [],
  patientListRecords: [],
  calendarDate: dayjs().startOf("day"),
  appointmentDetailsById: null,
  appointmentStatusCounts: [],
  firstTimeAppointmentsCount: 0,
};

export const ScheduleSlice = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    getDoctorListRecords: (state, action) => {
      state.doctorListRecords = action.payload;
    },
    getStaffRecords: (state, action) => {
      state.staffRecords = action.payload;
    },
    getappointmentSlots: (state, action) => {
      state.appointmentSlots = action.payload;
    },
    setRescheduleSuccess: (state, action) => {
      state.rescheduleSuccess = action.payload;
    },
    setAppointmentCounts: (state, action) => {
      state.appointmentCounts = action.payload;
    },
    resetAppointmentCounts: (state, action) => {
      state.appointmentCounts = null;
    },
    setTotalSchedule: (state, action) => {
      state.totalSchedule = action.payload;
    },
    getNurseListRecords: (state, action) => {
      state.nurseListRecords = action.payload;
    },
    getPatientRecords: (state, action) => {
      state.patientListRecords = action.payload;
    },
    setCalendarDate(state, action) {
      state.calendarDate = action.payload;
    },
    getAppointmentDetails(state, action) {
      state.appointmentDetailsById = action.payload;
    },
    resetAppointmentDetails: (state, action) => {
      state.appointmentDetailsById = null;
    },
    setAppointmentStatusCounts: (state, action) => {
      state.appointmentStatusCounts = action.payload;
    },
    setFirstTimeAppointmentsCount: (state, action) => {
      state.firstTimeAppointmentsCount = action.payload;
    },
  },
});

export const {
  getDoctorListRecords,
  getStaffRecords,
  getappointmentSlots,
  setRescheduleSuccess,
  setAppointmentCounts,
  resetAppointmentCounts,
  setTotalSchedule,
  getNurseListRecords,
  getPatientRecords,
  setCalendarDate,
  getAppointmentDetails,
  resetAppointmentDetails,
  setAppointmentStatusCounts,
  setFirstTimeAppointmentsCount,
} = ScheduleSlice.actions;

export default ScheduleSlice.reducer;
